module.exports = __webpack_public_path__ + "img/refresh.b07028bf.png";